import { Thread } from "duck/ui/chat/types";

import { clientServerPydanticAI } from "shared/api/axios";
import { createURL } from "shared/api/utils";

interface ThreadShare {
  id: string;
  thread_id: string;
  messages_up_to_serial_number: number;
  created_at: string;
  created_by: string;
}

export const createThreadShare = async (
  threadId: string
): Promise<ThreadShare> => {
  const response = await clientServerPydanticAI.post(
    createURL(["threads", threadId, "share"])
  );

  return response.data;
};

// The share ID travels in the body rather than the path to keep the only credential a share has out of request logs.
export const consumeThreadShare = async (shareId: string): Promise<Thread> => {
  const response = await clientServerPydanticAI.post(
    createURL(["threads", "consume_share"]),
    { share_id: shareId }
  );

  return response.data;
};
